import { EmulatorTvTuner } from '../framework/EmulatorTvTuner';
export class ContemporaryResearch {
    constructor(socket, log) {
        this.socket = socket;
        this.closedCaption = false;
        this.firmwareVersion = 'V1.58';
        this.modelNumber = 'unknown';
        this.power = false;
        this.tuner = '0';
        this.tv = new EmulatorTvTuner();
        this.volume = 50;
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'audioStatus',
                regExp: /^>(\d?)(SV)$/,
                callback: (match) => {
                    const id = match[1] ? parseInt(match[1], 10) : 1;
                    if (id < 1 || id > 9) {
                        this.socket.send('ERROR: invalid device ID');
                    }
                    else {
                        const response = this.createAudioResponse(id);
                        this.socket.send(response);
                    }
                },
            },
            {
                name: 'basicCommand',
                regExp: /^>(\d?)(TD|TU|T\^)$/,
                callback: (match) => {
                    const id = match[1] ? parseInt(match[1], 10) : 1;
                    if (id < 1 || id > 9) {
                        this.socket.send('ERROR: invalid device ID');
                    }
                    else if (match[2] === 'TU') {
                        this.tv.channelUp();
                        const response = this.createTunerResponse(id);
                        this.socket.send(response);
                    }
                    else if (match[2] === 'TD') {
                        this.tv.channelDown();
                        const response = this.createTunerResponse(id);
                        this.socket.send(response);
                    }
                    else {
                        this.socket.send(match[2]);
                    }
                },
            },
            {
                name: 'channelSet',
                regExp: /^>(\d?)TC=(\d+)-?(\d*)$/,
                callback: (match) => {
                    const id = match[1] ? parseInt(match[1], 10) : 1;
                    if (id < 1 || id > 9) {
                        this.socket.send('ERROR: invalid device ID');
                    }
                    else {
                        const major = Math.min(Math.max(parseInt(match[2], 10), 1), 999);
                        const minor = Math.min(Math.max(match[3] ? parseInt(match[3], 10) : 1, 1), 999);
                        this.tv.channelSet(major, minor);
                        const response = this.createTunerResponse(id);
                        this.socket.send(response);
                    }
                },
            },
            {
                name: 'channelStatus',
                regExp: /^>(\d?)ST$/,
                callback: (match) => {
                    const id = match[1] ? parseInt(match[1], 10) : 1;
                    if (id < 1 || id > 9) {
                        this.socket.send('ERROR: invalid device ID');
                    }
                    else {
                        const response = this.createTunerResponse(id);
                        this.socket.send(response);
                    }
                },
            },
            {
                name: 'channelName',
                regExp: /^>(\d?)NC$/,
                callback: (match) => {
                    const id = match[1] ? parseInt(match[1], 10) : 1;
                    if (id < 1 || id > 9) {
                        this.socket.send('ERROR: invalid device ID');
                    }
                    else {
                        const channel = this.tv.channel;
                        this.socket.send(`<${id}NC${channel.name}`);
                    }
                },
            },
            {
                name: 'closedCaption',
                regExp: /^>(\d?)Q0=?(\d)$/,
                callback: (match) => {
                    const id = match[1] ? parseInt(match[1], 10) : 1;
                    if (id < 1 || id > 9) {
                        this.socket.send('ERROR: invalid device ID');
                    }
                    else {
                        this.closedCaption = match[2] === '1';
                        const response = this.createQModeResponse(id);
                        this.socket.send(response);
                    }
                },
            },
            {
                name: 'frontPanelStatus',
                regExp: /^>(\d?)SS$/,
                callback: (match) => {
                    const id = match[1] ? parseInt(match[1], 10) : 1;
                    if (id < 1 || id > 9) {
                        this.socket.send('ERROR: invalid device ID');
                    }
                    else {
                        const response = this.createFrontPanelResponse(id);
                        this.socket.send(response);
                    }
                },
            },
            {
                name: 'key',
                regExp: /^>(\d?)KK=\d+$/,
                callback: (match) => {
                    const id = match[1] ? parseInt(match[1], 10) : 1;
                    if (id < 1 || id > 9) {
                        this.socket.send('ERROR: invalid device ID');
                    }
                    else {
                        // no response from device
                    }
                },
            },
            {
                name: 'power',
                regExp: /^>(\d?)(P0|P1)$/,
                callback: (match) => {
                    const id = match[1] ? parseInt(match[1], 10) : 1;
                    if (id < 1 || id > 9) {
                        this.socket.send('ERROR: invalid device ID');
                    }
                    else {
                        this.power = match[2] === 'P1';
                        const response = this.createTunerResponse(id);
                        this.socket.send(response);
                    }
                },
            },
            {
                name: 'productId',
                regExp: /^>(\d)ID$/,
                callback: (match) => {
                    const id = parseInt(match[1], 10);
                    if (id < 1 || id > 9) {
                        this.socket.send('ERROR: invalid device ID');
                    }
                    else {
                        this.socket.send(`<${id}ID${this.modelNumber} ${this.firmwareVersion}`);
                    }
                },
            },
            {
                name: 'programName',
                regExp: /^>(\d)NP$/,
                callback: (match) => {
                    const id = parseInt(match[1], 10);
                    if (id < 1 || id > 9) {
                        this.socket.send('ERROR: invalid device ID');
                    }
                    else {
                        const channel = this.tv.channel;
                        this.socket.send(`<${id}NP${channel.program}`);
                    }
                },
            },
            {
                name: 'qMode',
                regExp: /^>(\d)SQ$/,
                callback: (match) => {
                    const id = parseInt(match[1], 10);
                    if (id < 1 || id > 9) {
                        this.socket.send('ERROR: invalid device ID');
                    }
                    else {
                        const response = this.createQModeResponse(id);
                        this.socket.send(response);
                    }
                },
            },
            {
                name: 'tuningFormat',
                regExp: /^>(\d)S0=(\d)$/,
                callback: (match) => {
                    const id = parseInt(match[1], 10);
                    if (id < 1 || id > 9) {
                        this.socket.send('ERROR: invalid device ID');
                    }
                    else {
                        const tuner = parseInt(match[2], 10);
                        if (tuner < 0 || tuner > 4) {
                            this.socket.send('ERROR: invalid tuner');
                        }
                        else {
                            this.tuner = match[2];
                            // no response from device
                        }
                    }
                },
            },
            {
                name: 'volume',
                regExp: /^>(\d)VH(\d+)$/,
                callback: (match) => {
                    const id = parseInt(match[1], 10);
                    if (id < 1 || id > 9) {
                        this.socket.send('ERROR: invalid device ID');
                    }
                    else {
                        const volume = parseInt(match[2], 10);
                        if (volume < 0 || volume > 100) {
                            this.socket.send('ERROR: invalid volume');
                        }
                        else {
                            this.volume = volume;
                            const response = this.createAudioResponse(id);
                            this.socket.send(response);
                        }
                    }
                },
            },
            {
                name: 'volumeMute',
                regExp: /^>(\d)(VX|VM)$/,
                callback: (match) => {
                    const id = parseInt(match[1], 10);
                    if (id < 1 || id > 9) {
                        this.socket.send('ERROR: invalid device ID');
                    }
                    else {
                        this.volumeMute = match[2] === 'VM';
                        const response = this.createAudioResponse(id);
                        this.socket.send(response);
                    }
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send('ERROR: invalid command');
                },
            },
        ];
    }
    createTunerResponse(id) {
        const channel = this.tv.channel;
        let value = `<${id}T`;
        value += `${this.power ? 'U' : 'M'}`;
        value += channel.major.toString().padStart(3, '0');
        // video mute U, 0 = RF input, A for Air, C for Cable, 0 = 1080i resolution
        value += `U0${this.tuner === '1' ? 'A' : 'C'}0`;
        value += channel.minor.toString().padStart(3, '0');
        value += 'x0';
        return value;
    }
    createAudioResponse(id) {
        let value = `<${id}V`;
        value += `${this.power ? 'U' : 'M'}`;
        value += (this.volume * 0.63).toFixed(0).padStart(2, '0');
        value += this.volumeMute ? 'M' : 'U';
        value += 'x';
        value += this.volume.toString().padStart(3, '0');
        return value;
    }
    createFrontPanelResponse(id) {
        let value = `<${id}S`;
        value += 'x';
        value += `${this.tuner}`;
        value += `0084200xxxx`;
        return value;
    }
    createQModeResponse(id) {
        let value = `<${id}Q`;
        value += `${this.closedCaption ? '1' : '0'}`;
        value += `130290`;
        value += `${this.closedCaption ? '1' : '0'}`;
        value += `1xx`;
        return value;
    }
}
ContemporaryResearch.emulatorType = 'socketEmulator';
ContemporaryResearch.key = '-MQS5Bci_J6eWlACQVLD';
